import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, signal } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import type { WaHideEvent } from '@web.awesome.me/webawesome-pro';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-tc-acceptance-dialog',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    styleUrl: './tc-acceptance-dialog.css',
    templateUrl: './tc-acceptance-dialog.html',
})
export class TcAcceptanceDialog {
    readonly auth = inject(AuthService);

    readonly isAccepting = signal(false);
    readonly hasAgreed = signal(false);
    private readonly allowClose = signal(false);

    readonly isOpen = computed(() => {
        const state = this.auth.state();
        return state.status === 'authenticated' && state.user !== null && !state.user.tc_accepted;
    });

    // Reset dialog state when it opens for a (possibly different) user.
    // noinspection JSUnusedLocalSymbols
    private readonly resetOnOpenEffect = effect(() => {
        if (this.isOpen()) {
            this.isAccepting.set(false);
            this.hasAgreed.set(false);
            this.allowClose.set(false);
        }
    });

    onHide(e: WaHideEvent) {
        // Block Escape key / light dismiss, but allow programmatic close (accept or decline)
        if (!this.allowClose()) {
            e.preventDefault();
        }
    }

    async onAccept() {
        this.isAccepting.set(true);
        try {
            await this.auth.acceptTerms();
            this.allowClose.set(true);
        } finally {
            this.isAccepting.set(false);
        }
    }

    onDecline() {
        this.allowClose.set(true);
        this.auth.logout();
    }
}
